export default __webpack_public_path__ + "static/media/location_preview_park.ae85d70a.svg";